exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input {\r\n  direction: rtl;\r\n}\r\n\r\nlabel {\r\n  font-weight: bold;\r\n}\r\n\r\nh3,\r\nh5 {\r\n  direction: rtl;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/equipment-sign/equipment-sign.component.css
// module id = ../../../../../src/app/equipment-sign/equipment-sign.component.css
// module chunks = main